// extracted by mini-css-extract-plugin
export default {"searchBox":"Search_searchBox__wjp1u","inputSearch":"Search_inputSearch__So0T7"};